/* eslint-disable no-undef */

export default () => {
  if (typeof ymaps === 'undefined' || $('#contacts-map').length === 0) {
    return;
  }

  const centerCoords = [55.757950, 37.602010];

  ymaps.ready(() => {
    const myMap = new ymaps.Map('contacts-map', {
      center: centerCoords,
      zoom: 16,
      controls: ['zoomControl'],
    });

    const myPlacemark = new ymaps.Placemark(
      [55.757950, 37.602010],
      {
        iconCaption: 'Dolce Vita Kids',
        balloonContent: 'Москва, Цветной бульвар, 2',
      },
      {
        iconLayout: 'default#image',
        iconImageHref: `${WPJS.siteUrl}/assets/img/common/mark.svg`,
        iconImageSize: [40, 63.2],
        iconImageOffset: [-20, -65],
      },
    );
    myMap.geoObjects.add(myPlacemark);

    myMap.behaviors.disable('scrollZoom');
  });
};
